<template>
  <div>
    <!-- 废弃申请 -->
    <el-dialog :title="$t('message.abandonmentApplication')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="680px" center>
      <div class="content">
        <!-- 废弃原因: -->
        <div class="row">
          <div class="label">
            {{ $t("message.reasonForAbandonment") }}
            ：
          </div>
          <div class="val">
            <el-input v-model="datas.reason" onfocus="this.select()" type="textarea"></el-input>
          </div>
        </div>
        <!-- 联系截图 -->
        <div class="row">
          <div class="label">
            {{ $t("message.contactScreenshot") }}
            ：
          </div>
          <div class="val">
            <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleAvatarSuccess"
              :obefore-upload="beforeAvatarUpload" :limit="4" drag>
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
        <!--废弃类型-->
        <div class="row">
          <div class="label">
            {{ $t("message.discardType") }}
            ：
          </div>
          <div class="val">
            <el-radio v-model="datas.abandon_type" label="1">{{ $t('message.customerRequestAbandonment') }}</el-radio>
            <el-radio v-model="datas.abandon_type" label="0">{{ $t('message.unableToContactTimeoutDiscard')
              }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      datas: {
        porder_sn: this.$route.query.porder_sn,
        reason: '',
        images: [],
        abandon_type: '1'

      },
      images: [],
      dialogVisible: false,
      dialogImageUrl: '',
      imgDialogVisible: false
    };
  },
  methods: {
    // 保存
    save() {
      this.datas.images = []
      this.images.forEach(item => {
        this.datas.images.push(item.response.data)
      })
      if (this.datas.images == false) return this.$message.error('请上传联系截图')
      if (this.datas.reason == '') return this.$message.error('请填写废弃原因')
      this.$api.porderApi.discardCreate(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
      });
    },
    handleRemove(file, fileList) {
      this.images = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 上传
    handleAvatarSuccess(res, file, fileList) {
      console.log(fileList);
      this.images = fileList;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },

  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(2) !important;
}

/deep/ .el-upload-dragger {
  width: 120px;
  height: 120px;

}

/deep/.el-upload--picture-card {
  border: 0;
}

.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      flex: 1;

    }

    .val {
      flex: 4;
      line-height: 40px;
    }
  }
}
</style>